import { ScheduledAction } from '@demind-inc/core';
import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();

export interface SuggestAllAIPlanState {
  statusLines: string[];
  schedules: ScheduledAction[];
  summary: string | null;
  isLoading: boolean;
  acceptedIds: string[];
  autoAcceptedIds: string[];
  discardedIds: string[];
  error: string | null;
  /** YYYY-MM-DD the last Plan My Day run was for. */
  targetDate: string | null;
  /** Todo IDs selected in the last Plan My Day run (used for modal-less reruns). */
  lastRunTodoIds: string[];
  /** Routine activity IDs selected in the last Plan My Day run. */
  lastRunRoutineIds: string[];
}

export const suggestAllAIPlanStateAtom = atom<SuggestAllAIPlanState>({
  key: 'suggestAllAIPlan.state',
  default: {
    statusLines: [],
    schedules: [],
    summary: null,
    isLoading: false,
    acceptedIds: [],
    autoAcceptedIds: [],
    discardedIds: [],
    error: null,
    targetDate: null,
    lastRunTodoIds: [],
    lastRunRoutineIds: [],
  },
});

export const isAllPlanPanelOpenAtom = atom<boolean>({
  key: 'suggestAllAIPlan.isPanelOpen',
  default: false,
});

/** Optional YYYY-MM-DD seed when opening Plan My Day intro (e.g. rerun from results). */
export const planMyDayIntroSeedDateAtom = atom<string | null>({
  key: 'suggestAllAIPlan.planMyDayIntroSeedDate',
  default: null,
});
